import {Outlet, Route} from "react-router-dom";
import {ContaContabilIndexPage} from "@components/contaContabil/pages/ContaContabilIndexPage.tsx";
import {ContasContabeisPage} from "@components/contaContabil/pages/ContasContabeisPage.tsx";
import {ContaContabilCadastraPage} from "@components/contaContabil/pages/ContaContabilCadastraPage.tsx";
import {ContaContabilPage} from "@components/contaContabil/pages/ContaContabilPage.tsx";
import {_Sitemap} from "@localization/siteMap/breadcrumbs/_Sitemap.ts";
import {
    CcDistribuivelSelectionPage
} from "@components/contaContabil/valoresDistribuiveis/pages/CcDistribuivelSelectionPage.tsx";
import {CcDistribuivelPage} from "@components/contaContabil/valoresDistribuiveis/pages/CcDistribuivelPage.tsx";


export const ContaContabilRoutes = () => {
    const rt = _Sitemap.contaContabil;
    const vd = rt.children.valoresDistribuiveis;


    return <Route path={'contaContabil'} key={'contaContabil'} element={<Outlet/>}
                  children={[
                      <Route path={'menu'} key={'contaContabil/consulta'}
                             element={<ContaContabilIndexPage/>}/>,
                      <Route path={'consulta'} key={'contaContabil/consulta'}
                             element={<ContasContabeisPage searchType={'Conta'}/>}/>,
                      <Route path={'cadastro'} key={'contaContabil/cadastro'}
                             element={<ContaContabilCadastraPage/>}/>,
                      <Route path={'detalhes'} key={'contaContabil/detalhes'}
                             element={<ContaContabilPage/>}/>,
                      <Route path={vd.url} key={vd.fullUrl} element={<Outlet/>}
                              children={[
                                  <Route path={'lista'} key={vd.children.lista.fullUrl}
                                         element={<CcDistribuivelSelectionPage/>}/>,
                                  <Route path={'detalhes'} key={vd.children.detalhes.fullUrl}
                                         element={<CcDistribuivelPage/>}/>,
                              ]}
                      />,
                  ]}
    />;
};
